import { useEffect, useState } from 'react'
import { PersonalizationEngineType } from '@/state/personalization-engine/models'

type Props = {
  data: PersonalizationEngineType[]
}

export const useChartCardPagination = ({ data }: Props) => {
  const [pagination, setPagination] = useState({
    total: 0,
    limit: 5,
    page: 1,
    pages: 0,
  })

  const handleChangeLimit = (newLimit: number) => {
    if (Math.ceil(pagination.total / newLimit) < pagination.page) {
      setPagination({
        ...pagination,
        limit: newLimit,
        page: 1,
        pages: Math.ceil(pagination.total / newLimit),
      })
    } else {
      setPagination({
        ...pagination,
        limit: newLimit,
        pages: Math.ceil(pagination.total / newLimit),
      })
    }
  }

  const handleChangePage = (newPage: number) => {
    setPagination({
      ...pagination,
      page: newPage,
    })
  }

  useEffect(() => {
    setPagination({
      total: data.length || 0,
      limit: 5,
      page: 1,
      pages: Math.ceil(data.length / 5),
    })
  }, [data])

  const paginatedRows =
    data?.slice(
      (pagination.page - 1) * pagination.limit,
      (pagination.page - 1) * pagination.limit + pagination.limit,
    ) || []

  return {
    paginatedRows,
    pagination,
    handleChangeLimit,
    handleChangePage,
  }
}
